import ListItem from '@lib/components/ListItem';
import TitleBar, * as ITitleBar from '@lib/components/TitleBar';
import { AlarmProps } from '@lib/containers/Alarm';
import * as React from 'react';
import './Alarm.css';

declare var Waves: any;

interface IAlarmState {
  showMenu: boolean;
  showTrash: boolean;
  showPencil: boolean;
}

class Alarm extends React.Component<AlarmProps, IAlarmState> {

  public constructor(props: AlarmProps) {
    super(props);
    this.state = { showMenu: false, showPencil: false, showTrash: false };
  }

  public componentDidMount() {
    Waves.attach('div.listItem', 'waves-light');
  }

  /**
   * Fired when user clicks on an item 
   * @param state 
   * @param event 
   */
  public onItemClick(item: string, event: React.MouseEvent<HTMLDivElement>) {
    event.stopPropagation();
  }


  /**
   * Fired when user click on menu hamburger button
   * @param event 
   */
  public onMenuClick(event: React.MouseEvent<HTMLDivElement>) {
    this.props.onGoBack();
  }


  /**
   * Fired when user click on refresh button
   * @param event 
   */
  public onRefreshClick(event: React.MouseEvent<HTMLDivElement>) {
    this.props.onRefresh(this.props.site.device!.id);
  }



  public render() {

    if (this.props.alarm === undefined) {
      window.location.pathname = '/';
      window.location.hash = '';
      return null;
    }

    const i18n = this.props.i18n.Alarm;

    const alarms = [];
    for (const alarm of this.props.alarm) {
      let detail = alarm.label + ' ' + alarm.v + alarm.unit;
      if (alarm.ty === 'INPUTALARMBEGIN' || alarm.ty === 'INPUTALARMEND'
        || alarm.ty === 'SENSORDEFAULT' || alarm.ty === 'SENSORDEFAULTEND'
        || alarm.ty === 'POWERSUPPLYBATTERYDOWN' || alarm.ty === 'POWERSUPPLYBATTERYUP'
        || alarm.ty === 'POWERSUPPLYSECTORDOWN' || alarm.ty === 'POWERSUPPLYSECTORUP'
      ) {
        detail = alarm.label;
      }
      alarms.push(<ListItem leftIcoClass={alarm.ty} icoClass='none' title={i18n[alarm.ty]} detail={new Date(alarm.t).toLocaleString('fr-FR', { timeZone: "Europe/Paris" })} detail2={detail} notif={0} key={alarm._id} onClick={this.onItemClick.bind(this, alarm)} />);
    }

    return (
      <div className="standardPage alarms">

        <TitleBar
          leftIcon={ITitleBar.ICO_CHEVRON_LEFT}
          onLeftButtonClick={this.onMenuClick.bind(this, this.state)}
          title={i18n.title}
          rightIcon={this.props.syncing ? ITitleBar.ICO_SYNC_ALT_ROTATING : ITitleBar.ICO_SYNC_ALT}
          onRightButtonClick={this.onRefreshClick.bind(this, this.state)}
        />
        <div id="alarmList">
          {alarms}
        </div>
      </div>
    );
  }
}

export default Alarm;



// WEBPACK FOOTER //
// ./src/pages/Alarm.tsx